import { DefaultCommandProps } from './index';

import Base from './base';

const TimeSelect = ({ label, value, onChange }: DefaultCommandProps) => (
  <Base id={label} value={value} onChange={(e) => onChange(label, e)} type="time" />
);

export default TimeSelect;
